import { CommonModule } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular/standalone';
import { AppCommonModule } from 'src/app/common.module';
import { MainDialogComponent } from 'src/app/components/main-dialog/main-dialog.component';
import { UsersService } from 'src/app/services/users.service';
import { managerAdminRoles } from 'src/app/utility/role';

@Component({
  selector: 'app-answer-dialog',
  templateUrl: './answer.dialog.html',
  styleUrls: ['./answer.dialog.scss'],
  imports: [
    AppCommonModule,
    CommonModule,
    MainDialogComponent,
  ],
})
export class AnswerDialogComponent {
  private formBuilder = inject(FormBuilder);
  private _modal = inject(ModalController);
  private usersService = inject(UsersService);

  readonly managerRoles = managerAdminRoles;
  role = computed(() => this.usersService.role());

  formGroup = this.formBuilder.group({
    description: ['', Validators.required],
  });

  save() {
    const value = this.formGroup.value;
    this._modal.dismiss(value.description);
  }

  dismiss() {
    this._modal.dismiss();
  }
}
